// extracted by mini-css-extract-plugin
export default {"brick-layout":"BrickLayout_brick-layout__5eVdq"};